/* eslint-disable consistent-return */
import _ from 'lodash';

import { orderProductsForDiscountPrecedence } from '../utilities';
import { mergeSatisfiers } from './common';

const checkStandardConditions = ({
  conditions,
  continueCheckingConditionsAfterSatisfied,
  itemToConsiderLast,
  logicOperator,
  pendingRewardsSatisfiers,
  items,
  specialsSettings,
  itemsForAPrice,
}) => {
  // sort out items by discount precedence, because our conditions will always be in alphabetical order
  const sortedItems = orderProductsForDiscountPrecedence(
    items,
    specialsSettings,
    itemsForAPrice.enabled ? 'rewards' : 'conditions',
    true,
    itemToConsiderLast
  );
  let adjustedSortedItems = sortedItems;

  if (itemToConsiderLast) {
    adjustedSortedItems = _.reject(sortedItems, ['key', itemToConsiderLast.key]);
    adjustedSortedItems.push(itemToConsiderLast);
  }
  let satisfiers = {};

  // clear out prior conditions
  _.forEach(conditions, (condition) => {
    condition.reset();
  });

  _.forEach(adjustedSortedItems, (item) => {
    // eslint-disable-next-line lodash/prefer-filter
    _.forEach(conditions, (condition) => {
      // as long as we haven't used satisfied this condition...
      if (condition?.satisfied === false) {
        // check if this item is a.) eligible for this condition, and if so, b.) whether it satisfies this condition
        const { satisfied: conditionSatisfied, satisfiers: conditionSatisfiers } = condition.evaluateItem({
          item,
          pendingConditionsSatisfiers: satisfiers,
          pendingRewardsSatisfiers,
        });

        if (conditionSatisfied) {
          // add this condition to our running list of satisfiers
          satisfiers = mergeSatisfiers(satisfiers, conditionSatisfiers);

          // break out of our condition loop early if we have our singular OR satisfier and we're not continuing to check past satisfaction
          if (logicOperator === 'or' && !continueCheckingConditionsAfterSatisfied) {
            return false;
          }

          // remove any half applied satisfiers that might have been used in this satisfied condition
          const otherConditions = _.reject(conditions, ['condition._id', condition?.condition?._id]);
          _.forEach(otherConditions, (other) => {
            other.removeSatisfiers(condition);
          });
        }
      }
    });

    // break out of item loop early if we have our singular OR satisfier and we're not continuing to check past satisfaction
    if (logicOperator === 'or' && _.some(conditions, 'satisfied') && !continueCheckingConditionsAfterSatisfied) {
      return false;
    }

    // break out of item loop early if every AND condition is satisfied
    if (logicOperator === 'and' && _.every(conditions, 'satisfied')) {
      return false;
    }
  });

  // reset previous conditions
  _.forEach(conditions, (condition) => {
    condition.setPrevious();
  });

  if (logicOperator === 'or' && _.some(conditions, 'satisfied')) {
    return { satisfied: true, satisfiers };
  }

  if (logicOperator === 'and' && _.every(conditions, 'satisfied')) {
    return { satisfied: true, satisfiers };
  }

  return { satisfied: false, satisfiers: {} };
};

export default checkStandardConditions;
